import { AppConfigModel } from '../abstract/app-config.model';

export class LedgerEntryType extends AppConfigModel {

    static override CLASS_NAME: string = 'LedgerEntryType';

    public readonly category!: string;
    public readonly debitCredit!: string;
    public readonly settlementRule!: string;

}
